import React from 'react';
import PropTypes from 'prop-types';

import {RootProd} from './Root.prod.jsx';
import {RootDev} from './Root.dev.jsx';

/*export default ():JSX.Element => {
  return process.env.NODE_ENV === 'production'
    ? React.lazy(() => import('./Root.prod.jsx'))
    : React.lazy(() => import('./Root.dev.jsx'));
};*/

export function Root (props) {
  if (process.env.NODE_ENV === 'production') {
    return <RootProd {...props} />;
  } else {

    return (<RootDev store={props.store} history={props.history} persistor={props.persistor}/>);
  }
}

Root.propTypes = {
  store: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  persistor: PropTypes.object.isRequired,
};
